import React from 'react';
import { LocatorElsewhere, LocatorUnactivated, LocatorUnauthorized, VehicleElsewhere, VehiclePaired, LocatorOffline, LocatorLost, LocatorPaired, LocatorPairedElsewhere } from './types';
import { jsx as _jsx } from "react/jsx-runtime";
export default class IntermediateScreen extends React.Component {
  render() {
    const {
      type,
      selectedObject
    } = this.props;
    if (type === 'vehiclePaired') {
      return /*#__PURE__*/_jsx(VehiclePaired, {
        ...this.props
      });
    }
    if (type === 'vehicleElsewhere') {
      return /*#__PURE__*/_jsx(VehicleElsewhere, {
        ...this.props
      });
    }
    if (!selectedObject?.locator) {
      return /*#__PURE__*/_jsx(LocatorUnauthorized, {
        ...this.props
      });
    }
    if (type === 'locatorUnactivated') {
      return /*#__PURE__*/_jsx(LocatorUnactivated, {
        ...this.props
      });
    }
    if (type === 'locatorOffline') {
      return /*#__PURE__*/_jsx(LocatorOffline, {
        ...this.props
      });
    }
    if (type === 'locatorElsewhere') {
      return /*#__PURE__*/_jsx(LocatorElsewhere, {
        ...this.props
      });
    }
    if (type === 'locatorLost') {
      return /*#__PURE__*/_jsx(LocatorLost, {
        ...this.props
      });
    }
    if (type === 'locatorPaired') {
      return /*#__PURE__*/_jsx(LocatorPaired, {
        ...this.props
      });
    }
    if (type === 'locatorPairedElsewhere') {
      return /*#__PURE__*/_jsx(LocatorPairedElsewhere, {
        ...this.props
      });
    }
    return null;
  }
}